export const AUD_MOBILE_INCREASE_RECS_DEPTH = 'aud_mobile_bx923_increase_recs_depth';

export const EXPERIMENTS: string[] = [AUD_MOBILE_INCREASE_RECS_DEPTH];
